import { render, staticRenderFns } from "./IdeaFormPage.vue?vue&type=template&id=7d190c62&scoped=true&"
import script from "./IdeaFormPage.vue?vue&type=script&lang=js&"
export * from "./IdeaFormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d190c62",
  null
  
)

export default component.exports